<template>
    <div class=" scroll-smooth">
        <!-- Meta Tags -->
        <Head title="Inicio" />

        <section class="min-h-screen bg-[#560093] py-24">
            <div class="container">
                <h2 class="shadow-peach text-2xl sm:text-4xl before:content-['Términos_y_Condiciones'] text-center">
                    <span class="relative z-20">Términos y Condiciones</span>
                </h2>

                <div class="w-full max-w-6xl mx-auto bg-white px-4 sm:px-8 py-8 rounded-xl mt-8">
                    <div class="font-roboto text-black" v-html="configuration.terms">
                    </div>
                </div>

            </div>
        </section>


    </div>
</template>

<script>
export default {
    name: 'Legals',
    props: ['configuration']
};
</script>
<style>

</style>
